/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chats_Delete_Chat_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete this chat? This action cannot be undone." |
*
* @param {Chats_Delete_Chat_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chats_delete_chat_confirm_description = /** @type {((inputs?: Chats_Delete_Chat_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chats_Delete_Chat_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bist du sicher, dass du diesen Chat löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.")
	return /** @type {LocalizedString} */ ("Are you sure you want to delete this chat? This action cannot be undone.")
});